import { render } from "./Creatures.vue?vue&type=template&id=5cf52cbe&lang=true"
import script from "./Creatures.vue?vue&type=script&lang=js"
export * from "./Creatures.vue?vue&type=script&lang=js"
script.render = render

export default script